import { circadiaEngineProvider, localStorageProvider } from "../AppController";
import { isVitalsSubdomain } from "./subdomain";

const isCircadia = circadiaEngineProvider.isWindowCircadia();

/**
 * Determines if PIN authentication is required.
 *
 * PIN is required when:
 * - Running inside the Circadia native app (not web)
 * - AND not using SSO login
 * - AND not in Vitals AI mode (subdomain check only - beta feature check happens in appRouter)
 *
 * @param skipPinForVitalsAI - Optional flag to skip PIN for Vitals AI beta users (passed from components with Redux access)
 */
export const isPIN = (skipPinForVitalsAI?: boolean) => {
  // Skip PIN for Vitals AI subdomain users
  if (isVitalsSubdomain()) return false;

  // Skip PIN for Vitals AI beta users (when flag is passed from component)
  if (skipPinForVitalsAI) return false;

  if (isCircadia && localStorageProvider.get("sso") !== "true") return true;

  return false;
};
